import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./login.css";
import image1 from "../../assets/image-1.png";
import { ThreeDot } from "react-loading-indicators";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("access_token");

  const handleForgotPassword = async () => {
    setError("");
    setMessage("");

    if (!email) {
      setError("Please enter your email");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/user/reset-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json",Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },

        body: JSON.stringify({ email }),
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.message || data.error || "Error sending email");
      } else {
        setMessage("Password reset link or OTP has been sent to your email.");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image">
        <img src={image1} alt="Forgot Password" />
      </div>
      <div className="signin-details-container">
        <div className="signin-form">
          <h2>Forgot Password</h2>
          <input
            type="email"
            placeholder="Enter your email"
            className="email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {error && <p className="error-message">{error}</p>}
          {message && <p className="success-message">{message}</p>}

          <div className="btn-container">
            <button className="signin-button" onClick={handleForgotPassword}>
              {loading ? (
                <ThreeDot color={["#ffffff"]} size="small" />
              ) : (
                "Send reset link"
              )}{" "}
            </button>
          </div>

          <p className="signin-subtitle">
            <Link to="/">Back to Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
